import PositionedContainer from './PositionedContainer'

export default PositionedContainer
